/*
 * FAQ accordion for sections/eb-sub-faq.
 *
 * Progressive enhancement over native <details>: without this script every
 * question still opens and closes, just without the animation or the
 * one-open-at-a-time rule. With it, a summary click is intercepted so the
 * answer's height can be animated before [open] is set or removed.
 */

class EbSubFaq extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.eb-sub-faq__item'));
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.items.forEach((item) => {
      item.querySelector('summary').addEventListener('click', (event) => {
        event.preventDefault();
        if (item.open && !item.classList.contains('is-closing')) {
          this.close(item);
        } else {
          this.items.forEach((other) => {
            if (other !== item && other.open) this.close(other);
          });
          this.open(item);
        }
      });
    });
  }

  /*
   * Height and the negative top margin move together. Animating height alone
   * left the -10px pull-up in place at height 0, so the item jumped by that
   * much the moment [open] dropped (and again at the start of an open).
   */
  animate(item, from, to, onFinish) {
    const panel = item.querySelector('.eb-sub-faq__a');
    const pull = getComputedStyle(panel).getPropertyValue('--eb-faq-pull').trim() || '0px';
    const fromMargin = item._ebAnimation ? getComputedStyle(panel).marginTop : from === 0 ? '0px' : pull;
    if (item._ebAnimation) item._ebAnimation.cancel();

    if (this.reduceMotion.matches) {
      onFinish();
      return;
    }

    const animation = panel.animate(
      [
        { height: `${from}px`, marginTop: fromMargin, opacity: from === 0 ? 0 : 1 },
        { height: `${to}px`, marginTop: to === 0 ? '0px' : pull, opacity: to === 0 ? 0 : 1 },
      ],
      { duration: 280, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
    );
    item._ebAnimation = animation;
    animation.onfinish = () => {
      item._ebAnimation = null;
      onFinish();
    };
  }

  open(item) {
    const panel = item.querySelector('.eb-sub-faq__a');
    const from = item.classList.contains('is-closing') ? panel.offsetHeight : 0;
    item.classList.remove('is-closing');
    item.open = true;
    this.animate(item, from, panel.scrollHeight, () => {});
  }

  close(item) {
    const panel = item.querySelector('.eb-sub-faq__a');
    item.classList.add('is-closing');
    this.animate(item, panel.offsetHeight, 0, () => {
      item.open = false;
      item.classList.remove('is-closing');
    });
  }
}

if (!customElements.get('eb-sub-faq')) {
  customElements.define('eb-sub-faq', EbSubFaq);
}
